import { render } from "./AddSurveys.vue?vue&type=template&id=c2b08b6a&scoped=true"
import script from "./AddSurveys.vue?vue&type=script&lang=js"
export * from "./AddSurveys.vue?vue&type=script&lang=js"

import "./AddSurveys.vue?vue&type=style&index=0&id=c2b08b6a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b08b6a"]])

export default __exports__